import React from 'react';
import { Modal, Box, Typography, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface PaymentWaitingModalProps {
  open: boolean;
  status: 'waiting' | 'success' | 'error';
  message?: string;
  mode?: 'payment' | 'refund';
}

const PaymentWaitingModal: React.FC<PaymentWaitingModalProps> = ({
  open,
  status,
  message,
  mode = 'payment'
}) => {
  const isRefund = mode === 'refund';

  const getStatusContent = () => {
    switch (status) {
      case 'waiting':
        return (
          <>
            <CircularProgress 
              size={80} 
              sx={{ 
                color: isRefund ? '#ff9800' : '#1976d2',
                mb: 3
              }} 
            />
            <Typography 
              variant="h4" 
              sx={{ 
                color: isRefund ? '#ff9800' : '#1976d2',
                fontWeight: 'bold',
                textAlign: 'center',
                mb: 2
              }}
            >
              {isRefund ? 'Cihaz Bekleniyor...' : 'Ödeme Bekleniyor...'}
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#666',
                textAlign: 'center'
              }}
            >
              {message || (isRefund ? 'İade işlemi yapılıyor...' : 'Lütfen kartı okutunuz')}
            </Typography>
          </>
        );
      
      case 'success':
        return (
          <>
            <CheckCircleIcon 
              sx={{ 
                fontSize: 80,
                color: '#4caf50',
                mb: 3
              }} 
            />
            <Typography 
              variant="h4" 
              sx={{ 
                color: '#4caf50',
                fontWeight: 'bold',
                textAlign: 'center',
                mb: 2
              }}
            >
              {isRefund ? 'İade Edildi!' : 'Ödeme Alındı!'}
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#666',
                textAlign: 'center'
              }}
            >
              {message || (isRefund ? 'İade işlemi başarıyla tamamlandı' : 'İşlem başarıyla tamamlandı')}
            </Typography>
          </>
        );
      
      case 'error':
        return (
          <>
            <ErrorIcon 
              sx={{ 
                fontSize: 80,
                color: '#f44336',
                mb: 3
              }} 
            />
            <Typography 
              variant="h4" 
              sx={{ 
                color: '#f44336',
                fontWeight: 'bold',
                textAlign: 'center',
                mb: 2
              }}
            >
              {isRefund ? 'İade Başarısız!' : 'İşlem Başarısız!'}
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#666',
                textAlign: 'center'
              }}
            >
              {message || (isRefund ? 'İade işlemi başarısız oldu' : 'Kartlı ödeme işlemi başarısız oldu')}
            </Typography>
          </>
        );
      
      default:
        return null;
    }
  };

  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      onClose={() => {}} // Backdrop click'i devre dışı bırakmak için boş fonksiyon
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999, // En üstte görünmesi için
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Yarı saydam siyah arka plan
          backdropFilter: 'blur(2px)', // Hafif bulanıklık efekti
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          borderRadius: 4,
          padding: 6,
          minWidth: 400,
          minHeight: 300,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          outline: 'none',
        }}
      >
        {getStatusContent()}
      </Box>
    </Modal>
  );
};

export default PaymentWaitingModal;
